import { createAction } from 'redux-actions';
export var ADD_PASSENGER_IDS = 'ADD_PASSENGER_IDS';
export var REMOVE_PASSENGER_IDS = 'REMOVE_PASSENGER_IDS';
export var SET_PASSENGER_IDS = 'SET_PASSENGER_IDS';
export var addPassengerIds = createAction(ADD_PASSENGER_IDS, function (ids) { return ids; });
export var removePassengerIds = createAction(REMOVE_PASSENGER_IDS, function (ids) { return ids; });
export var setPassengerIds = createAction(SET_PASSENGER_IDS, function (ids) { return ids; });
